import { api } from "../../lib/api";

export interface Price {
  id: string;
  securityId: string;
  priceDate: string;
  open: string | null;
  high: string | null;
  low: string | null;
  close: string;
  previousClose: string | null;
  volume: string | null;
  source: string;
  createdAt: string;
}

export interface ManualPriceInput {
  priceDate: string;
  close: string;
  previousClose?: string | null;
  open?: string | null;
  high?: string | null;
  low?: string | null;
  volume?: string | null;
}

export interface ImportError {
  line: number;
  ticker?: string;
  error: string;
}

export interface ImportBatch {
  id: string;
  filename: string | null;
  status: string;
  rowCount: number | null;
  successCount: number | null;
  errorCount: number | null;
  errorLog: ImportError[];
  createdAt: string;
}

export const priceHistory = (securityId: string, limit = 90) =>
  api<{ data: Price[] }>(`/admin/securities/${securityId}/prices?limit=${limit}`).then((r) => r.data);

export const upsertPrice = (securityId: string, body: ManualPriceInput) =>
  api<{ price: Price }>(`/admin/securities/${securityId}/prices`, { method: "POST", body }).then(
    (r) => r.price,
  );

export const importCsv = (csv: string, filename: string) =>
  api<{ batchId: string }>(
    `/admin/prices/import?filename=${encodeURIComponent(filename)}`,
    { method: "POST", body: csv, rawBody: true, headers: { "content-type": "text/csv" } },
  );

export const listBatches = () =>
  api<{ data: ImportBatch[] }>("/admin/prices/imports").then((r) => r.data);

export const getBatch = (id: string) =>
  api<{ batch: ImportBatch }>(`/admin/prices/imports/${id}`).then((r) => r.batch);
